<section class="left-nav-wrapper scroll-container">
  <h1 class="page-title mb-4">Automatic Payroll</h1>
  <div class="d-md-flex d-sm-block" *ngIf="payGrid !== undefined">
    <div style="max-width: 500px">
      <img src="assets/images/auto_payroll_home.png" style="height: 350px" />
      <div id="beforeYouBegin" [innerHtml]="beforeYouBeginText"></div>
    </div>
    <div class="row align-self-center">
      <div class="col-md-11 col-xl-7 offset-md-1">
        <div class="row">
          <div class="col-sm-12">
            <div *ngIf="payGrid" class="mb-5">
              <h4 *ngIf="!payGrid.IsAutomaticSkipped" class="cp-green">
                Worksheet entry in progress
              </h4>
              <h4 *ngIf="payGrid.IsAutomaticSkipped" class="cp-green">
                Automatic processing skipped for this period
              </h4>
              <small class="cp-green"
                >Last edit by {{ payGrid.LastEditBy }} on
                {{ payGrid.LastEditOn | date: 'MM/dd/yyyy h:mma' }}</small
              >
            </div>
            <h4 *ngIf="payGrid === null" class="cp-green mb-5">Worksheet Ready</h4>
          </div>
          <div class="col-sm-12">
            <label>Schedule</label>
            <div class="form-control" disabled="disabled">{{ schedule }}</div>
          </div>
          <div class="col-sm-6">
            <label>Period End Date</label>
            <div class="form-control" disabled="disabled">{{ periodEnd | date: 'MM/dd/yyyy' }}</div>
          </div>
          <div class="col-sm-6">
            <label>Pay Date</label>
            <div class="form-control" disabled="disabled">{{ payDate | date: 'MM/dd/yyyy' }}</div>
          </div>
          <div class="col-sm-12">
            <label>Frequency</label>
            <div class="form-control" disabled="disabled">{{ frequency }}</div>
            <fieldset [disabled]="disableCtrls">
              <div class="d-flex mt-3 action-btns">
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'payroll_auto_payroll_home_start_worksheet' }"
                  *ngIf="payGrid === null"
                  class="btn btn-primary"
                  (click)="startWorksheet()">
                  Start Worksheet
                </button>
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'payroll_auto_payroll_home_resume_worksheet' }"
                  *ngIf="payGrid"
                  class="btn btn-primary"
                  (click)="resumeWorksheet()">
                  Resume Worksheet
                </button>
                <button
                  cpGTagEvent
                  [params]="{ event_label: 'payroll_auto_payroll_home_skip' }"
                  class="btn btn-secondary me-2"
                  (click)="skipAutomaticPay()">
                  Skip Automatic this period
                </button>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
